import '@mantine/tiptap/styles.css';
import '@mantine/core/styles.css';
import '@tiptap/extension-table';

import { useEffect } from "react";
import { RichTextEditor } from "@mantine/tiptap";

import { ArticleIcon } from "@phosphor-icons/react";
import StarterKit from "@tiptap/starter-kit";
import { TableCell, TableKit } from '@tiptap/extension-table';
import { WrapperSVG } from "@components/WrapperSVG/WrapperSVG";
import styles from "./rich-editor.module.scss";
import { useEditor } from "@tiptap/react";
import clsx from "clsx";

type RichEditorPropsT = {
  inline?: boolean;
  initialContent?: string;
  label?: string;
  handleContent: (content: string) => void;
  error?: string;
  minHeight?: number;
  btn?: React.ReactElement;
};

export const RichEditor: React.FC<RichEditorPropsT> = ({
  inline = false,
  initialContent = "",
  handleContent,
  label = "Текст новости",
  error,
  minHeight = 150,
  btn
}) => {
  const editor = useEditor({
    shouldRerenderOnTransaction: true,
    extensions: [
      StarterKit,
      TableKit.configure({
        table: { resizable: true },
        tableCell: false,
      }),
      TableCell
    ],
    content: initialContent,
    editable: true,

    onUpdate: ({ editor }) => {
      handleContent(editor.getHTML());
    }
  });

  useEffect(() => {
    if (editor && initialContent && initialContent.indexOf('table') !== -1) {
      editor.commands.setContent(initialContent);
    }
  }, [editor, initialContent]);

  return (
    <div className={inline ? styles.container_inline : styles.container}>
      <p className={styles.Label}>
        <WrapperSVG color="green" cursor={false}>
          <ArticleIcon size={24} />
        </WrapperSVG>
        {label}{btn}
      </p>
      <RichTextEditor
        editor={editor}
        style={{ minHeight: minHeight, width: '100%' }}
        className={clsx(styles.Editor, {
          [styles.Editor_error]: !!error,
        })}
      >
        <RichTextEditor.Toolbar sticky stickyOffset={60}>
          <RichTextEditor.ControlsGroup>
            <RichTextEditor.Bold />
            <RichTextEditor.Italic />
            <RichTextEditor.Strikethrough />
          </RichTextEditor.ControlsGroup>

          <RichTextEditor.ControlsGroup>
            <RichTextEditor.H1 />
            <RichTextEditor.H2 />
            <RichTextEditor.H3 />
            <RichTextEditor.H4 />
          </RichTextEditor.ControlsGroup>

          <RichTextEditor.ControlsGroup>
            <RichTextEditor.Blockquote />
            <RichTextEditor.Hr />
          </RichTextEditor.ControlsGroup>

          <RichTextEditor.ControlsGroup>
            <RichTextEditor.Link />
            <RichTextEditor.Unlink />
          </RichTextEditor.ControlsGroup>
        </RichTextEditor.Toolbar>

        <RichTextEditor.Content />
      </RichTextEditor>
      {error && <span className="error-text">{error}</span>}
    </div>
  );
};
